import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { MatDialog } from '@angular/material/dialog';
import {
  ActivatedRoute,
  NavigationEnd,
  Router,
  RouterEvent,
} from '@angular/router';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { UserService } from 'src/app/core/services/user.service';
import { ICase } from '../../interfaces/case.interface';
import { CasesService } from '../../../../core/services/cases.service';
import { Subscription } from 'rxjs';
import { CaseService } from 'src/app/modules/case/services/case.service';
import { UnitsService } from 'src/app/core/services/units.service';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { Sort, MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { CreateCaseComponent } from '../create-case/create-case.component';
import { ConfirmComponent } from 'src/app/components/shared/components/confirm/confirm.component';
import { RemitCaseComponent } from '../remit-case/remit-case.component';
import { GenerateTasksComponent } from 'src/app/modules/case/components/generate-tasks/generate-tasks.component';
import { first } from 'rxjs/operators';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { FinishCaseComponent } from '../finishCase/finishCase.component';
import * as moment from 'moment';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import { SocketService } from 'src/app/core/services/socket.service';

/** Paginador en español (antes «Items per page», «1 – 1 of 1»). */
export function paginadorEs(): MatPaginatorIntl {
  const p = new MatPaginatorIntl();
  p.itemsPerPageLabel = 'Por página';
  p.nextPageLabel = 'Página siguiente';
  p.previousPageLabel = 'Página anterior';
  p.firstPageLabel = 'Primera página';
  p.lastPageLabel = 'Última página';
  p.getRangeLabel = (page: number, size: number, total: number) => {
    if (!total) return '0 de 0';
    const desde = page * size + 1;
    const hasta = Math.min(desde + size - 1, total);
    return `${desde} – ${hasta} de ${total}`;
  };
  return p;
}

@Component({
  selector: 'cases-content-new-view',
  templateUrl: './cases-content-new-view.component.html',
  styleUrls: ['./cases-content-new-view.component.scss'],
  providers: [{ provide: MatPaginatorIntl, useFactory: paginadorEs }],
})
export class CasesContentNewViewComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatTable) table: MatTable<ICase>;
  unitId!: string;
  displayedColumns: string[] = [
    'options',
    'gai',
    'description',
    'caseType',
    'creator',
    'createdAt',
    'datePast',
    // 'state',
    // 'levelRisk',
    // 'dateReport',
    // 'assing',
    // 'taskInCase',
    //'x',
  ];
  dataSource: MatTableDataSource<any>;
  status = {
    initial: 'Sin Asignar',
    running: 'En proceso',
    tobeApproved: 'Por aprobar',
    toFinalize: 'Finalizado',
    archived: 'Archivado',
    pending: 'Pendiente',
    assigned: 'Asignado',
    refused: 'Rechazado',
  };
  valueTab: number = 0;
  routerSuscription: Subscription;

  tobeApproved = [];
  toFinalize = [];
  pending = [];
  initial: ICase[] = [];
  running = [];

  tobeApprovedFillter = [];
  toFinalizeFillter = [];
  pendingFillter = [];
  initialFillter = [];
  runningFillter = [];

  showInitialData = false;
  showFinalizeData = false;
  showRunningData = false;
  showPendingData = false;
  showApprovedData = false;

  durationInSeconds = 4;

  users: IUser[] = [];
  caseTypes: ICaseType[] = [];

  allCases: any[] = [];

  sortedData = []; // Datos ordenados

  allCasesInitial = [];
  allCasesRunning = [];
  allCasesTobeApproved = [];
  allCasesToFinalize = [];
  allCasesAssigned = [];
  allCasesRefused = [];
  allAlertsFinalized = [];
  allAlertsRechazado = [];
  allAlertsAbierto = [];
  loading = false;
  unitinfo = null;
  constructor(
    private readonly casesService: CasesService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    public userService: UserService,
    private readonly dialog: MatDialog,
    private readonly caseService: CaseService,
    private readonly unitService: UnitsService,
    private _snackBar: MatSnackBar,
    private readonly alertService: AlertService,
    private socket: SocketService
  ) {
    this.unitId = route.snapshot.paramMap.get('id');
    this.socketOn();
    this.update();
    this.sortedData = this.allCases.slice();
  }

  update() {
    this.getDataAbierto();
    this.getDataAssigned();
    this.getDataRunning();
    this.getDataTobeApproved();
    this.getDataToFinalize();
    this.getAlertByFilterAbierto({ codes: ['02', '03'] });
    this.getAlertByFilterRechazado();
    this.getAlertByFilterFinalized();
    this.getDataAll();
    this.getDataVu();
  }

  socketOn() {
    this.socket.socket.on('new-alert', async (msj: { ok: boolean }) => {
      this.update();
    });
  }

  ngOnDestroy(): void {
    this.routerSuscription?.unsubscribe();
  }

  setData(cases: ICase[]) {
    this.dataSource = new MatTableDataSource(cases);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  openSnackBar(icase) {
    const snackbarRef: MatSnackBarRef<any> = this._snackBar.open(
      'Caso eliminado',
      'Deshacer',
      {
        duration: 4000,
      }
    );
    let deshacer = false;

    let cases;
    let index;

    switch (this.valueTab) {
      case 0:
        cases = this.allCasesAssigned;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1);
        this.allCasesAssigned.splice(index, 1);
        break;
      case 1:
        cases = this.allCasesRunning;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1);
        this.allCasesRunning.splice(index, 1);
        break;
      case 2:
        cases = this.allCasesTobeApproved;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1);
        this.allCasesTobeApproved.splice(index, 1);
        break;
      case 3:
        cases = this.allCases;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1);
        this.allCases.splice(index, 1);
        break;
      default:
        break;
    }

    this.setData(cases);
    this.table.renderRows();

    snackbarRef.onAction().subscribe(() => {
      deshacer = true;
      switch (this.valueTab) {
        case 0:
          index = cases.findIndex((item) => item._id == icase._id);
          cases.splice(index, 0, icase);
          this.allCasesAssigned.splice(index, 0, icase);
          break;
        case 1:
          index = cases.findIndex((item) => item._id == icase._id);
          cases.splice(index, 0, icase);
          this.allCasesRunning.splice(index, 0, icase);
          break;
        case 2:
          cases = this.allCasesTobeApproved;
          index = cases.findIndex((item) => item._id == icase._id);
          cases.splice(index, 0, icase);
          this.allCasesTobeApproved.splice(index, 0, icase);
          break;
        case 3:
          cases = this.allCases;
          index = cases.findIndex((item) => item._id == icase._id);
          cases.splice(index, 0, icase);
          this.allCases.splice(index, 0, icase);
          break;
        default:
          break;
      }
      this.setData(cases);
      this.table.renderRows();
    });
    setTimeout(() => {
      if (!deshacer) {
        this.caseService
          .delete(icase._id, this.userService.currentUser)
          .subscribe({
            next: () => {},
            error: (e) => {
              this.alert('Ha ocurrido un error al intentar eliminar el caso');
            },
          });
      }
    }, 4100);
  }

  async delete(icase) {
    let response = await this.confirm('¿Seguro deseas eliminar este caso?');
    if (response) {
      this.openSnackBar(icase);
    }
  }

  async seeCase(icase, status, a = undefined, b = undefined) {
    this.router.navigate([`/casesnew/${icase._id}`]);
  }

  confirm(message) {
    return new Promise((resolve) => {
      this.dialog
        .open(ConfirmComponent, {
          data: {
            title: message,
          },
        })
        .afterClosed()
        .subscribe({ next: (result) => resolve(result) });
    });
  }

  alert(message) {
    this.dialog.open(SuccessComponent, { data: { title: message } });
  }

  get canMove() {
    return this.userService.permissions.changeColumnCases;
  }
  ngOnInit() {
    // console.log("current roles: ",this.userService.currentUser.role);
    this.alertService.filtroUrgentes.subscribe({
      next: (value: any) => {
        this.filterByOption(value.filter, value.option);
      },
    });
    this.casesService.caseCreated.subscribe({
      next: (newCase) => {
        this.initial.unshift(newCase);
        this.allCasesInitial.unshift(newCase);

        this.setData(this.allCasesInitial);
        this.table.renderRows();
      },
    });

    // this.alertService.alertImportedVu.subscribe({
    //   next: (newCases) => {
    //     this.initial = [...this.initial, ...newCases];
    //     this.allAlertsAbierto = [...this.allAlertsAbierto, ...newCases];
    //     if (this.valueTab == 0) {
    //       this.setData(this.allAlertsAbierto);
    //       this.table.renderRows();
    //     }
    //   },
    // });

    this.casesService.caseDeleted.subscribe({
      next: (caseDeleted) => {
        let index = 0;
        switch (caseDeleted.status) {
          case 'tobeApproved':
            index = this.tobeApproved.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.tobeApproved.splice(index, 1);
            break;
          case 'toFinalize':
            index = this.toFinalize.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.toFinalize.splice(index, 1);
            break;
          case 'running':
            index = this.running.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.running.splice(index, 1);
            break;
          case 'initial':
            index = this.initial.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.initial.splice(index, 1);
            break;
          case 'pending':
            index = this.pending.findIndex(
              (item) => item._id == caseDeleted._id
            );
            this.pending.splice(index, 1);
            break;
          default:
            console.log('Error');
            break;
        }
      },
    });
    this.casesService.caseEdited.subscribe({
      next: (caseEdited) => {
        let index = 0;
        switch (caseEdited.status) {
          case 'tobeApproved':
            index = this.tobeApproved.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.tobeApproved.splice(index, 1, caseEdited);
            break;
          case 'toFinalize':
            index = this.toFinalize.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.toFinalize.splice(index, 1, caseEdited);
            break;
          case 'running':
            index = this.running.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.running.splice(index, 1, caseEdited);
            break;
          case 'initial':
            index = this.initial.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.initial.splice(index, 1, caseEdited);
            break;
          case 'pending':
            index = this.pending.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.pending.splice(index, 1, caseEdited);
            break;
          case 'assigned':
            index = this.pending.findIndex(
              (item) => item._id == caseEdited._id
            );
            this.pending.splice(index, 1, caseEdited);
            break;
          default:
            console.log('Error');
            break;
        }
      },
    });

    this.casesService.filterDataRasSearch.subscribe({
      next: async (filters) => {
        await this.getDataAssigned(filters);
        await this.getDataRunning(filters);
        await this.getDataTobeApproved(filters);
        await this.getDataToFinalize(filters);
        await this.getAlertByFilterAbierto(filters);
        await this.getAlertByFilterRechazado(filters);
        await this.getAlertByFilterFinalized(filters);

        await this.getDataAll();
        //  this.change();
      },
    });
    this.casesService.caseFinished.subscribe({
      next: (caseFinished) => {
        const index = this.toFinalize.findIndex(
          (item) => item._id == caseFinished._id
        );
        this.toFinalize.splice(index, 1);
      },
    });
    this.getCaseTypes();
  }
  ngAfterViewInit() {
    // this.dataSource.sort = this.sort;
    setTimeout(() => this.hideTabLabelsIfNoSeeCase(), 0);
  }
  reset(value) {
    const types = [
      'initial',
      'assigned',
      'toFinalize',
      'tobeApproved',
      'running',
      'pending',
    ];
    for (const key of types) {
      this[key] = [];
    }
    switch (value) {
      case 0:
        this.allAlertsAbierto = [];

        break;
      case 1:
        this.allCasesAssigned = [];

        break;
      case 2:
        this.allCasesRunning = [];

        break;
      case 3:
        this.allCasesTobeApproved = [];

        break;
      case 4:
        this.allCasesToFinalize = [];
        break;
      case 5:
        this.allCases = [];

        break;

      case 6:
        // this.allCasesRefused = [];
        this.allAlertsFinalized = [];

        break;
      // case 7:
      default:
        break;
    }
  }

  get canFinish() {
    return this.userService.permissions?.finishCases;
  }
  get canSee() {
    return this.userService.permissions?.seeCases;
  }
  async getDataAll(filters: any = {}) {
    this.loading = true;
    this.casesService.getDataByUnitList(this.unitId, filters).subscribe({
      next: (data: any) => {
        this.reset(5);
        this.loading = false;
        this.allCases = data;
      },
    });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }

  async getDataAbierto(filters: any = {}) {
    this.alertService.alertCreated.subscribe({
      next: (newCase) => {
        console.log('getDataAbierto', newCase);
        this.initial.unshift(newCase);
        this.allAlertsAbierto.unshift(newCase);
        if (this.valueTab == 0) {
          this.setData(this.allAlertsAbierto);
          this.table.renderRows();
        }
      },
    });
  }
  async getDataVu() {
    this.alertService.alertImportedVu.subscribe({
      next: (newCases) => {
        newCases = newCases.map((alert) => {
          alert.description = alert.descripcion;
          return alert;
        });
        this.initial = [...newCases, ...this.initial];
        this.allAlertsAbierto = [...newCases, ...this.allAlertsAbierto];

        if (this.valueTab == 0) {
          this.setData(this.allAlertsAbierto);
          this.table.renderRows();
        }
      },
    });
  }
  async getDataAssigned(filters: any = {}) {
    filters.state = 'assigned';
    this.loading = true;
    await this.casesService.getDataByUnitList(this.unitId, filters).subscribe({
      next: (data: any) => {
        this.reset(1);
        this.loading = false;
        this.allCasesAssigned = data;
        if (this.valueTab == 1) {
          this.setData(this.allCasesAssigned);
        }
      },
    });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }

  async getDataRunning(filters: any = {}) {
    filters.state = 'running';
    this.loading = true;
    this.casesService.getDataByUnitList(this.unitId, filters).subscribe({
      next: (data: any) => {
        this.reset(2);
        this.loading = false;
        this.allCasesRunning = data;
        if (this.valueTab == 2) {
          this.setData(this.allCasesRunning);
        }
        // this.setData(this.allCasesRunning);
      },
    });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }

  async getDataTobeApproved(filters: any = {}) {
    filters.state = 'tobeApproved';
    this.loading = true;
    this.casesService.getDataByUnitList(this.unitId, filters).subscribe({
      next: (data: any) => {
        this.reset(3);

        this.loading = false;
        this.allCasesTobeApproved = data;

        if (this.valueTab == 3) {
          this.setData(this.allCasesTobeApproved);
        }
      },
    });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }

  async getDataToFinalize(filters: any = {}) {
    filters.state = 'toFinalize';
    this.loading = true;
    await this.casesService.getDataByUnitList(this.unitId, filters).subscribe({
      next: (data: any) => {
        this.reset(4);

        this.loading = false;
        this.allCasesToFinalize = data;
        if (this.valueTab == 4) {
          this.setData(this.allCasesToFinalize);
        }
      },
    });
    this.unitService.getById(this.unitId).subscribe((res) => {
      this.unitinfo = res;
    });
  }
  getAlertByFilterAbierto(filter: any = {}) {
    filter.state = 'initial';

    this.alertService.getalertByList(filter).subscribe((res) => {
      this.reset(0);
      this.loading = false;

      this.allAlertsAbierto = res;
      this.allAlertsAbierto = this.allAlertsAbierto.map((alert) => {
        alert.description = alert.descripcion;
        return alert;
      });
      if (this.valueTab == 0) {
        this.setData(this.allAlertsAbierto);
      }
    });
  }

  getAlertByFilterFinalized(filter: any = {}) {
    filter.state = 'finalized';

    this.alertService.getalertByList(filter).subscribe((res) => {
      this.reset(6);
      this.loading = false;

      this.allAlertsFinalized = res;
      this.allAlertsFinalized = this.allAlertsFinalized.map((alert) => {
        alert.description = alert.descripcion;
        return alert;
      });
      if (this.valueTab == 6) {
        this.setData(this.allAlertsFinalized);
      }
    });
  }

  filterByOption(filter: any = {}, option) {
    filter.state = 'finalized';
    //para alertas urgentes:
    // Alertas no atendidas timer_out=true
    // Alertas Cliente no Localizado  estadoContacto = 2
    // Alertas confirmadas respuesta = confirmar
    // Alertas Rechazada respuesta = rechazar
    // Alertas Rechazada con cuenta condicionada respuesta = rechazar cuentaMultiTitular=true
    switch (option) {
      case 'no atendidas':
        filter.timer_out = true;
        break;
      case 'no Localizado':
        filter.estadoContacto = 2;
        break;
      case 'confirmadas':
        filter.respuesta = 'confirmar';
        break;
      case 'Rechazada':
        filter.respuesta = 'rechazar';
        filter.cuentaMultiTitular = false;
        break;
      case 'Rechazada con cuenta':
        filter.respuesta = 'rechazar';
        filter.cuentaMultiTitular = true;
        break;
    }

    // Feedback visible al cambiar el filtro de Urgentes.
    if (this.valueTab == 6) this.loading = true;
    this.alertService.getalertByList(filter).subscribe((res) => {
      this.reset(6);
      this.loading = false;

      this.allAlertsFinalized = res;
      this.allAlertsFinalized = this.allAlertsFinalized.map((alert) => {
        alert.description = alert.descripcion;
        return alert;
      });
      if (this.valueTab == 6) {
        this.setData(this.allAlertsFinalized);
      }
    });
  }
  getAlertByFilterRechazado(filter: any = {}) {
    filter.state = 'refused';
    // No toca la pestaña 6 (Urgentes = finalizadas): si respondía después
    // de getAlertByFilterFinalized vaciaba Urgentes.
    this.alertService.getalertByList(filter).subscribe((res) => {
      this.allAlertsRechazado = res;
    });
  }
  hideTabLabelsIfNoSeeCase() {
    if (!this.canSee) {
      const indicesToHide = [0, 5];
      const labels = document.querySelectorAll('.mat-tab-label');
      this.valueTab = 1;
      indicesToHide.forEach((idx) => {
        if (labels[idx]) {
          (labels[idx] as HTMLElement).style.display = 'none';
        }
      });
    } else {
      // Si canSee es true, asegúrate de mostrar los tabs por si antes estaban ocultos
      const indicesToShow = [0, 5];
      const labels = document.querySelectorAll('.mat-tab-label');
      indicesToShow.forEach((idx) => {
        if (labels[idx]) {
          (labels[idx] as HTMLElement).style.display = '';
        }
      });
    }
  }
  nothing() {}

  get countRunning() {
    return this.running?.length;
  }
  get countInitial() {
    return this.initial?.length;
  }
  get countApproved() {
    return this.tobeApproved?.length;
  }
  get countFinalize() {
    return this.toFinalize?.length;
  }
  get countPending() {
    return this.pending?.length;
  }

  async orderByFilter(fil, status) {
    switch (status) {
      case 'initial':
        this[status + 'Filter'] = fil;
        break;
      case 'tobeApproved':
        this[status + 'Filter'] = fil;
        break;
      case 'pending':
        this[status + 'Filter'] = fil;
        break;
      case 'running':
        this[status + 'Filter'] = fil;
        break;
      case 'initial':
        this[status + 'Filter'] = fil;
        break;
    }
    this.casesService.getDataByUnitFilter(this.unitId, {}).subscribe({
      next: (data: any) => {
        this.loading = false;
        this[status] = data[status];
        //si tiene analista
        if (fil.analist) {
          this[status] = this[status].filter((r) => {
            return r.assigned._id == fil.analist;
          });
        }
        if (fil.caseType) {
          this[status] = this[status].filter((r) => {
            return r.caseType._id == fil.caseType;
          });
        }
        if (fil.date && fil.date != null) {
          this[status] = this[status]
            .slice()
            .sort(
              (a, b) =>
                new Date(b.createdAt).getTime() -
                new Date(a.createdAt).getTime()
            );
        }
        if (!fil.date && fil.date != null) {
          this[status] = this[status]
            .slice()
            .sort(
              (a, b) =>
                new Date(a.createdAt).getTime() -
                new Date(b.createdAt).getTime()
            );
        }
      },
    });
  }

  getCaseTypes() {
    this.unitService.getTypeCases(this.unitId).subscribe({
      next: (caseTypes) => {
        this.caseTypes = caseTypes;
        this.findUser();
      },
    });
  }

  findUser() {
    for (let caseType of this.caseTypes) {
      this.userService.getUsersByRole(caseType.role).subscribe({
        next: (users: any) => {
          this.users = [...this.users, ...users];
          const uniqueIds = new Set();

          this.users = this.users.filter((element) => {
            const isDuplicate = uniqueIds.has(element._id);

            uniqueIds.add(element._id);

            if (!isDuplicate) {
              return true;
            }

            return false;
          });
        },
      });
    }
  }

  approval(icase) {
    this.dialog
      .open(ConfirmComponent, {
        data: {
          title: '¿Deseas aprobar este caso?',
          type: null,
          approbvalStatus: icase.approvalStatus,
        },
        minWidth: '400px',
      })
      .afterClosed()
      .subscribe(async (response) => {
        if (response) {
          this.caseService.acceptApproval(icase._id).subscribe({
            next: async (updatedCase: any) => {
              const c = await this.getCaso(icase._id);
              this.updateCase(c);
              this.alert('El caso ha sido aprobado');

              const remitInstructions: any = c.caseType.remitTo;
              const shouldRemit =
                remitInstructions &&
                remitInstructions.some(
                  (instruction) => instruction.remitIf === 'approved'
                );

              if (shouldRemit) {
                this.remitTo(c);
                return;
              }

              this.generateTasks(icase);
            },
          });
        }
      });
  }

  async getCaso(id) {
    const icase = await this.caseService.getCase(id).pipe(first()).toPromise();
    return icase;
  }

  async remitTo(icase) {
    if (!icase.caseType.remitTo || icase.caseType.remitTo.length === 0) {
      console.error(
        'remitTo fue llamado, pero no se encontraron instrucciones de remisión.'
      );
      return;
    }
    const approvedDestinations = icase.caseType.remitTo.filter(
      (instruction) => instruction.remitIf === 'approved'
    );

    if (approvedDestinations.length === 0) {
      console.warn(
        "remitTo fue llamado, pero ninguna instrucción coincidía con 'approved'."
      );
      this.generateTasks(icase);
      return;
    }

    this.dialog
      .open(RemitCaseComponent, {
        width: '600px',
        maxHeight: '80vh',
        data: {
          case: icase,
          destinations: approvedDestinations,
        },
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (remittalSucceeded: boolean) => {
          if (remittalSucceeded) {
            this.generateTasks(icase);
          }
        },
      });
  }
  finishCase(icase) {
    const { caseType } = icase;
    if (!caseType.remitTo || caseType.remitIf != 'finished')
      return this.finish(icase);
    this.dialog
      .open(RemitCaseComponent, {
        width: '600px',
        maxHeight: '80vh',
        data: icase,
        disableClose: true,
      })
      .afterClosed()
      .subscribe({
        next: (response) => {
          this.finish(icase);
        },
      });
  }

  finish(icase) {
    let appUnif: any;
    let secondAp = false;
    let controlRas;
    if (
      icase.caseType.approvalRoles?.levelTwo &&
      icase.approvalStatus == 'approved'
    ) {
      appUnif = icase?.apUnif;
    } else {
      appUnif = false;
    }

    if (icase?.caseType.approvalRoles?.levelTwo) secondAp = true;
    if (
      icase.caseType.approvalRoles?.levelTwo &&
      icase.approvalStatus == 'approved'
    ) {
      controlRas = icase?.numberRas ? true : false;
    } else {
      controlRas = false;
    }

    if (!appUnif && secondAp) {
      return this.alert('El caso no ha sido aprobado por UNIF');
    }

    if (!controlRas && secondAp) {
      return this.alert('El caso no posee Número de control RAS');
    }

    this.dialog
      .open(FinishCaseComponent, {
        width: '800px',
        maxHeight: '80vh',
        data: icase,
      })
      .afterClosed()
      .subscribe({
        next: (response) => {},
      });
  }

  canControlRas(icase) {
    try {
      const { approvalRoles } = icase?.caseType;
      const { approvalStatus } = icase;
      const roleId = this.userService.currentUser.role._id;
      if (
        approvalRoles?.levelOne == roleId &&
        approvalStatus == 'approved' &&
        icase.caseType.name == 'RAS'
      ) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }

  controlRas(icase) {
    if (
      icase.caseType.approvalRoles?.levelTwo &&
      icase.approvalStatus == 'approved'
    ) {
      return icase?.numberRas ? true : false;
    } else {
      return false;
    }
  }

  generateTasks(icase) {
    if (icase.caseType.generateTasks.length > 0) {
      this.dialog.open(GenerateTasksComponent, {
        width: '900px',
        maxHeight: '80vh',
        data: {
          case: icase._id,
          caseType: icase.caseType._id,
        },
        disableClose: true,
      });
    }
  }

  updateCase(icase) {
    let cases;
    let index;

    switch (this.valueTab) {
      case 0:
        cases = this.allCasesAssigned;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCasesAssigned.splice(index, 1, icase);
        break;
      case 1:
        cases = this.allCasesRunning;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCasesRunning.splice(index, 1, icase);
        break;
      case 2:
        cases = this.allCasesTobeApproved;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCasesTobeApproved.splice(index, 1, icase);
        break;
      case 3:
        cases = this.allCasesToFinalize;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCasesToFinalize.splice(index, 1, icase);
        break;
      // case 5:
      //   cases = this.allCasesRefused;
      //   index = cases.findIndex((item) => item._id == icase._id);
      //   cases.splice(index, 1, icase);
      //   this.allCasesRefused.splice(index, 1, icase);
      //   break;
      case 4:
        cases = this.allCases;
        index = cases.findIndex((item) => item._id == icase._id);
        cases.splice(index, 1, icase);
        this.allCases.splice(index, 1, icase);
        break;
      default:
        break;
    }

    this.setData(cases);
    this.table.renderRows();
  }

  needApproval(icase) {
    try {
      const { approvalRoles } = icase?.caseType;
      const { approvalStatus } = icase;
      const roleId = this.userService.currentUser.role._id;
      if (
        approvalRoles?.levelOne == roleId &&
        approvalStatus == 'requestLevelOne'
      ) {
        return true;
      }
      if (
        approvalRoles?.levelTwo == roleId &&
        approvalStatus == 'requestLevelTwo'
      ) {
        return true;
      }
      return false;
    } catch {
      return false;
    }
  }
  change(value = this.valueTab) {
    this.valueTab = value;
    const idx = this.displayedColumns.indexOf('datePast');
    if (this.valueTab === 6) {
      if (idx !== -1) this.displayedColumns.splice(idx, 1);
      console.log('this.valueTab ===6', this.displayedColumns);
    } else {
      if (idx === -1) this.displayedColumns.push('datePast');
      console.log('this.valueTab !=6', this.displayedColumns);
    }
    switch (value) {
      case 0:
        this.alertService.mandaValorUrgente.next(false);
        this.setData(this.allAlertsAbierto);
        break;
      case 1:
        this.alertService.mandaValorUrgente.next(false);
        this.setData(this.allCasesAssigned);
        break;
      case 2:
        this.alertService.mandaValorUrgente.next(false);
        this.setData(this.allCasesRunning);
        break;
      case 3:
        this.alertService.mandaValorUrgente.next(false);
        this.setData(this.allCasesTobeApproved);
        break;
      case 4:
        this.alertService.mandaValorUrgente.next(false);
        this.setData(this.allCasesToFinalize);
        break;
        // case 5:
        //           this.alertService.mandaValorUrgente.next(false);
        this.setData(this.allCasesRefused);
      //   break;
      case 5:
        this.alertService.mandaValorUrgente.next(false);
        this.setData(this.allCases);
        break;
      case 6:
        this.alertService.mandaValorUrgente.next(true);
        this.setData(this.allAlertsFinalized);
        // this.setData(this.allAlertsRechazado);
        // this.alertService.mandaValorUrgente.next(false);
        break;
      // case 7:

      //   break;
      default:
        break;
    }
    this.table.renderRows();
  }
  /** Color de «Días transcurridos»: verde < 7, ámbar < 30, rojo ≥ 30. */
  diasClase(dias: any): string {
    const n = Number(dias);
    if (!Number.isFinite(n)) return '';
    return n >= 30 ? 'bx-days--old' : n >= 7 ? 'bx-days--mid' : 'bx-days--new';
  }

  datePast(element) {
    let days;
    // if(element.status.toFinalize){
    // console.log("Element: ",element);
    // }
    const creationDate = element?.alert?.createdAt || element?.createdAt;

    if (!creationDate) {
      return 'Sin fecha';
    }

    switch (element?.status) {
      case 'toFinalize':
        days = moment(element.toFinalizeAt).diff(moment(creationDate), 'days');
        break;

      default:
        days = moment().diff(moment(creationDate), 'days');
    }

    return days;
  }

  sortData(sort: Sort) {
    this.dataSource.data.sort((a, b) => {
      return compare(a[sort.active], b[sort.active], sort.direction === 'asc');
    });
    this.setData(this.dataSource.data);
  }

  isGerente(): boolean {
    const role = this.userService.currentUser.role;
    return role?.createCases && role?.editCases && role?.deleteCases;
  }

  // Método para verificar si es Especialista
  isEspecialista(): boolean {
    const role = this.userService.currentUser.role;
    return role?.addTaskCase && role?.editTaskCase && role?.moveTaskCase;
  }

  // Método para determinar si mostrar los tabs específicos
  showGeneralRechazadoTabs(): boolean {
    return !(this.isGerente() || this.isEspecialista());
  }
}
function compare(
  a: number | string | Date,
  b: number | string | Date,
  isAsc: boolean
): number {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
